import Button from "@rio-cloud/rio-uikit/Button";
import ButtonToolbar from "@rio-cloud/rio-uikit/ButtonToolbar";
import {FormattedMessage} from "react-intl";
import {useDispatch, useSelector} from "react-redux";
import {useMediaQuery} from "react-responsive";

import {
    SearchContainer,
    StyledButtons
} from "@/components/atom/QuestionsListAssetTreeSummary/QuestionsListAssetTreeSummary.styles";
import SearchField from "@/components/atom/SearchField/SearchField";
import { TFaqIconStat } from "@/store/faq/types";
import {selectIsSearching, setIsSearching} from "@/store/search/searchSlice";

type QuestionsListAssetTreeSummaryProps = {
    faqIcons: TFaqIconStat[];
    onFilterSelect: (filter: string) => void;
    onSearch: (value: string) => void;
    activeIcon: string | null;
    isOnboarding: boolean;
};

const QuestionsListAssetTreeSummary = ({ faqIcons, activeIcon, onSearch, onFilterSelect, isOnboarding }: QuestionsListAssetTreeSummaryProps) => {

    const dispatch = useDispatch();
    const isSearching = useSelector(selectIsSearching);

    const isSmallScreen = useMediaQuery({ query: "(max-width: 47.5rem)" });

    const buttonToolbar = (
        <ButtonToolbar>
            <div className={isSmallScreen ? 'btn-group-vertical' : 'btn-group'}>
                {faqIcons.map(({icon, type, tooltipText}: TFaqIconStat) => (
                    <Button
                        data-testid={`filter-${type}`}
                        className={ isSmallScreen ? 'button-toolbar-group' : ''}
                        key={icon}
                        iconName={`rioglyph-${icon}`} active={icon === activeIcon}
                        onClick={() => onFilterSelect(type === activeIcon ? '' : type)}
                        disabled={isOnboarding}
                    >
                        <FormattedMessage id={tooltipText}/>
                    </Button>
                ))}
            </div>
        </ButtonToolbar>
    );

    const buttonSearch = (
        <SearchContainer>
            {!isSearching && (
                <Button
                    className={ isSmallScreen ? 'button-toolbar-group' : ''}
                    iconName='rioglyph-search-list'
                    onClick={() => dispatch(setIsSearching(true))}
                    disabled={isOnboarding}
                    data-testid="search-example-questions"
                >
                    <FormattedMessage id="chatPage.servicesSection.search" />
                </Button>
            )}

            {isSearching && <SearchField onSearch={(value) => onSearch(value)}/>}
        </SearchContainer>
    );

    return (
        <StyledButtons>
            <div className="buttons-wrapper">
                {buttonToolbar}
                {buttonSearch}
            </div>
        </StyledButtons>
    );
};

export default QuestionsListAssetTreeSummary;

